import { useDispatch, useSelector } from "react-redux";
import { requestLinkSocialAccount, setData } from "ducks/actions";
import { makeSelectAuthToken } from "ducks/selectors";
import { paths } from "utils/constants";
import { getRedirectURL, isWebview } from "utils/localStorage";
import { gotoUrl, pathWithChannel } from "utils/helpers";

/**
 * The hook is taking the ownership of linking social account details
 * and redirecting to correct route on both success and failure scenarios
 * @returns function to post linking social account details
 */
function useLinkUserAccount() {
  const dispatch = useDispatch();
  const currentAuthToken = useSelector(makeSelectAuthToken());

  const postLinkUserDetails = payload => {
    dispatch(requestLinkSocialAccount(payload, onPostLinkDetailsCallback));
  };

  const onPostLinkDetailsCallback = (response, errors) => {
    const ALREADY_HAS_LINKED_ACCOUNT = 400120;
    const CANNOT_LINK_CORPORATE_ACCOUNT = 400975;
    const { code: statusCode } = response || {};
    const mobileParams = {
      auth_token: currentAuthToken
    };
    if (errors) {
      if (isWebview()) {
        if (statusCode === ALREADY_HAS_LINKED_ACCOUNT) {
          dispatch(
            setData({
              key: "isModalView",
              data: { isModalView: true, type: "errorDuplicateSocialLogin" }
            })
          );
        } else if (statusCode === CANNOT_LINK_CORPORATE_ACCOUNT) {
          dispatch(
            setData({
              key: "isModalView",
              data: {
                isModalView: true,
                type: "errorCannotLinkCorporateAccount"
              }
            })
          );
        } else {
          return gotoUrl(getRedirectURL(), false, {}, true, mobileParams);
        }
      } else {
        gotoUrl(pathWithChannel(paths.LOG_IN, "web"), false, {}, false, {
          reset: true
        });
      }
    } else {
      // redirect back to mobile app by calling  redirect url
      return gotoUrl(getRedirectURL(), false, {}, true, mobileParams);
    }
  };

  return postLinkUserDetails;
}

export default useLinkUserAccount;
